import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Get_company_information = async (tablename) => { 
  const select_company_uid = Cookies.get("select_company_uid"); 
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
      const CollectionRef = collection(
      db,
      "companies",
      select_company_uid,
      tablename
    );

    const QueryRef = query(
      CollectionRef 
    );
      if (!QueryRef.empty) {
    const Snap = await getDocs(QueryRef); 
    const docData = Snap.docs[0].data();
    return { success: true, data: docData };
  }
  } catch (err) {
    return { success: false, error: err.message || "Unknown error" };
  }
};
